import { defineStore } from 'pinia'
const showContracts = import.meta.env.FEAT__CONTRACTS
const showCalendar = import.meta.env.FEAT__CALENDAR

// rename to account store
export const useAppStore = defineStore('app', {
  state: () => ({
    headerTitle: 'Readiness Academy',
    showHeaderChildPicker: false,
    showAccountFeatures: false,
    showContracts,
    showCalendar,
  }),
  actions: {
  },
  getters: {
    avaialableScreenHeight: (state)  => {
      return state.showHeaderChildPicker ? '14rem' : '11rem'
    },
  }
});